//
//
//
//
//

import axios from "axios";
export default {
  computed: {
    key() {
      return this.$route.fullPath;
    },
  },
  created() {
    const target =
      "https://api.weixin.qq.com/sns/oauth2/access_token?appid=wx51e13d91196bf291&secret=asdasdasd&code=adasd12323&grant_type=authorization_code";
    this.$store.commit("setCode", this.$route.query.code);
  },
};
